module.exports = __webpack_public_path__ + "img/sonic-min.59b81d48.png";